import { get } from '@/services/apiWrapper';

export const getAllContestsAPI = async (
  yearId: string,
  limit: string,
  page: string,
  search: string,
) => {
  const encodedSearchTerm = search ? encodeURIComponent(search.trim()) : '';
  const years = await get(
    `/admin/year/${yearId}/contests?page=${page}&limit=${limit}&q=${encodedSearchTerm}`,
  );
  return years;
};
